import { ChevronDown } from "lucide-react"

/** Animated down arrow for hero sections (bounce). */
export function ScrollIndicator() {
  return (
    <a
      href="#mission"
      className="absolute bottom-6 left-1/2 z-20 flex min-h-[44px] min-w-[44px] -translate-x-1/2 items-center justify-center rounded-full transition-all hover:scale-105 focus:outline-none focus:ring-2 focus:ring-white/50"
      style={{ color: "rgba(255,255,255,0.9)" }}
      aria-label="Scroll to content"
    >
      <ChevronDown className="h-8 w-8 animate-bounce sm:h-10 sm:w-10" strokeWidth={2.5} stroke="currentColor" />
    </a>
  )
}
